import { Platform } from "react-native";
import { fetchHttpDelete, fetchHttpGet, fetchHttpPost, fetchHttpPut } from "@lookiero/sty-psp-http";
import { VERSION } from "../../../version";

type OS = typeof Platform.OS;
type Device = Exclude<OS, "macos" | "windows">;

const device = Platform.OS as Device;

// `session.auth` is stored as "Bearer <token>"; the http client re-adds the
// "Bearer " prefix, so strip it here to avoid duplicating it.
const createHttpClients = (auth: string, apiUrl: () => string) => {
  const args = {
    apiUrl,
    getAuthToken: () => Promise.resolve(auth.replace(/^Bearer\s+/i, "")),
    device,
    version: VERSION,
  };

  return {
    httpGet: fetchHttpGet(args),
    httpPost: fetchHttpPost(args),
    httpPut: fetchHttpPut(args),
    httpDelete: fetchHttpDelete(args),
  };
};

export { createHttpClients };
